import {
  alphabetRegExp,
  Box,
  TextFieldForm,
  Typography,
} from 'web-library';
import React from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import ToggleDisplayEditFormItem from '../../../../components/ToggleDisplayEditFormItem';
import ControlledAutocomplete from '../../../../components/form-items/ControlledAutocomplete';
import { useStyles } from './style';
import { ContactDetailsItem } from '../../../../api/candidate/exam/model';
import { CandidateProfileFormDefaultValues } from '../../../../models';
import { LookupListApiItem } from '../../../../api/user/model';
import { useGetCountry } from '../../../../api-refactored/non-national-exam-registration/useGetCountry';
import { stringToSemanticDisplay } from '../../../../utils/DateUtils';
import ControlledDatePicker from "web-library/stories/atom/DatePicker/ControlledDatePicker";
interface SPERSDetailsProps {
  isEditState?: boolean;
  contactDetails: ContactDetailsItem | undefined;
  form?: UseFormReturn<Record<string, any>>;
  formDefaultValues?: CandidateProfileFormDefaultValues;
}

const defaultDOBPickerProps = {
  disableFuture: true,
  format: 'DEFAULT_DATE_FORMAT',
};

const countryDataOptions = (countryData: LookupListApiItem[] | undefined) => countryData || [];

const overseasResidencePeriodOfResidenceFromDisplay = (
  contactDetails: ContactDetailsItem | undefined
) => stringToSemanticDisplay(contactDetails?.overseasResidencePeriodOfResidenceFrom || '');

const overseasResidencePeriodOfResidenceToDisplay = (
  contactDetails: ContactDetailsItem | undefined
) => stringToSemanticDisplay(contactDetails?.overseasResidencePeriodOfResidenceTo || '');

const SPERSDetails = ({
  isEditState,
  contactDetails,
  form,
  formDefaultValues,
}: SPERSDetailsProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const { data: countryData } = useGetCountry({ enabled: isEditState, isSpers:true });

  return (
    <>
      <>
        <Typography variant="h3" className={classes.overseasResidence}>
          {t('exam->>NonNationalExam.OverseasResidence')}
        </Typography>
        {isEditState && (
          <Typography className={classes.overseasResidence}>
            {t('exam->>NonNationalExam.OverseasResidenceStatement')}
          </Typography>
        )}

        <Box className={classes.container}>
          <ToggleDisplayEditFormItem
            isEditState={isEditState}
            labelText={t('exam->>NonNationalExam.City')}
            valueText={contactDetails?.overseasResidenceCity}
            containerClassName={`${classes.formElementContainer} ${classes.halfWidthLeftItem}`}
            EditComponent={
              <TextFieldForm
                regExpToBlock={alphabetRegExp}
                form={form}
                label={t('exam->>NonNationalExam.City')}
                name="overseasResidenceCity"
                type="text"
                placeholder="Enter city"
                id="input-select-city"
                defaultValue={formDefaultValues?.overseasResidenceCity}
                error={!!form?.formState.errors.overseasResidenceCity}
                helperText={form?.formState.errors?.overseasResidenceCity?.message?.toString()}
                fullWidth
                isRequired
              />
            }
          />
          <ToggleDisplayEditFormItem
            isEditState={isEditState}
            labelText={t('exam->>NonNationalExam.ProvinceState')}
            valueText={contactDetails?.overseasResidenceState}
            containerClassName={`${classes.formElementContainer} ${classes.halfWidthRightItem}`}
            EditComponent={
              <TextFieldForm
                  form={form}
                label={t('exam->>NonNationalExam.ProvinceState')}
                name="overseasResidenceState"
                type="text"
                placeholder="Enter province/state"
                id="input-select-province-state"
                defaultValue={formDefaultValues?.overseasResidenceState}
                error={!!form?.formState.errors.overseasResidenceState}
                helperText={form?.formState.errors?.overseasResidenceState?.message?.toString()}
                fullWidth
              />
            }
          />
          <ToggleDisplayEditFormItem
            isEditState={isEditState}
            labelText={t('exam->>NonNationalExam.Country')}
            valueText={contactDetails?.overseasResidenceCountry}
            containerClassName={classes.formElementContainer}
            EditComponent={
              form &&
              countryData && (
                <ControlledAutocomplete
                  label={t('exam->>NonNationalExam.Country')}
                  control={form.control}
                  name="overseasResidenceCountry"
                  placeholder="Select country"
                  id="input-select-country"
                  options={countryDataOptions(countryData)}
                  getOptionLabel={(option) => (typeof option === 'string' ? option : option.description)}
                  error={!!form?.formState.errors.overseasResidenceCountry}
                  helperText={form?.formState.errors?.overseasResidenceCountry?.message?.toString()}
                  fullWidth
                  isRequired
                />
              )
            }
          />
          <ToggleDisplayEditFormItem
            isEditState={isEditState}
            labelText={t('exam->>NonNationalExam.PeriodOfOverseasResidenceFrom')}
            valueText={overseasResidencePeriodOfResidenceFromDisplay(contactDetails)}
            containerClassName={`${classes.formElementContainer} ${classes.halfWidthLeftItem}`}
            EditComponent={
              form && (
                    <ControlledDatePicker
                        control={form?.control}
                        // defaultValue={formDefaultValues?.overseasResidencePeriodOfResidenceFrom}
                        label={t('exam->>NonNationalExam.PeriodOfOverseasResidenceFrom')}
                        inputVariant="filled"
                        error={!!form?.formState.errors.overseasResidencePeriodOfResidenceFrom}
                        helperText={form?.formState.errors?.overseasResidencePeriodOfResidenceFrom?.message?.toString()}
                        isRequired
                        name="overseasResidencePeriodOfResidenceFrom"
                    />
              )
            }
          />
          <ToggleDisplayEditFormItem
            isEditState={isEditState}
            labelText={t('exam->>NonNationalExam.PeriodOfOverseasResidenceTo')}
            valueText={overseasResidencePeriodOfResidenceToDisplay(contactDetails)}
            containerClassName={`${classes.formElementContainer} ${classes.halfWidthRightItem} ${classes.periodOfOverseasResidenceTo}`}
            EditComponent={
              form && (
                    <ControlledDatePicker
                        name="overseasResidencePeriodOfResidenceTo"
                        control={form?.control}
                        // defaultValue={formDefaultValues?.overseasResidencePeriodOfResidenceTo}
                        label={t('exam->>NonNationalExam.PeriodOfOverseasResidenceTo')}
                        // labelFunc={() =>
                        //   form?.watch('overseasResidencePeriodOfResidenceTo')
                        //     ? stringToSemanticDisplay(
                        //         form?.watch('overseasResidencePeriodOfResidenceTo') as string
                        //       )
                        //     : 'Select date'
                        // }
                        inputVariant="filled"
                        disableFuture={false}
                        error={!!form?.formState.errors.overseasResidencePeriodOfResidenceTo}
                        helperText={form?.formState.errors?.overseasResidencePeriodOfResidenceTo?.message?.toString()}
                        isRequired
                    />
              )
            }
          />
        </Box>
      </>
    </>
  );
};

export default SPERSDetails;
